var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 0C3.61875 0 3 0.61875 3 1.375V20.625C3 21.3813 3.61875 22 4.375 22H18.125C18.8813 22 19.5 21.3813 19.5 20.625V5.5L14 0H4.375Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 5.5H19.5L14 0V4.125C14 4.88125 14.6187 5.5 15.375 5.5Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9.625L15.375 5.5H19.5V9.625Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 17.875C16.75 18.2531 16.4406 18.5625 16.0625 18.5625H0.9375C0.559375 18.5625 0.25 18.2531 0.25 17.875V11C0.25 10.6219 0.559375 10.3125 0.9375 10.3125H16.0625C16.4406 10.3125 16.75 10.6219 16.75 11V17.875Z",
    fill: "#0848C7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85216 16.5002C2.67066 16.5002 2.47266 16.4005 2.47266 16.1592V13.0373C2.47266 12.8393 2.67066 12.6963 2.85216 12.6963H4.11097C6.62309 12.6963 6.56741 16.5002 4.15978 16.5002H2.85216ZM3.19866 13.3666V15.8292H4.11097C5.59528 15.8292 5.66059 13.3666 4.11097 13.3666H3.19866Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67047 16.555C7.65366 16.599 6.59766 15.9225 6.59766 14.5757C6.59766 13.2234 7.65297 12.5586 8.67047 12.5586C9.63228 12.6074 10.6381 13.2729 10.6381 14.5757C10.6381 15.8792 9.63228 16.555 8.67047 16.555ZM8.60997 13.2736C7.99397 13.2736 7.32366 13.7081 7.32366 14.5764C7.32366 15.4399 7.99466 15.8799 8.60997 15.8799C9.24247 15.8799 9.91828 15.4399 9.91828 14.5764C9.91828 13.7074 9.24247 13.2736 8.60997 13.2736Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2852 14.5703C11.2852 13.5095 11.9507 12.5972 13.215 12.5972C13.6935 12.5972 14.073 12.7402 14.4738 13.0867C14.6223 13.2235 14.6388 13.4655 14.4903 13.6195C14.3418 13.7508 14.1163 13.735 13.9843 13.603C13.7595 13.3665 13.5285 13.3012 13.215 13.3012C12.3687 13.3012 11.9623 13.9007 11.9623 14.571C11.9623 15.253 12.3632 15.8793 13.215 15.8793C13.5285 15.8793 13.82 15.7521 14.073 15.5273C14.2428 15.3953 14.4793 15.4606 14.5783 15.5933C14.6663 15.7143 14.7096 15.9178 14.5178 16.1096C14.1328 16.4678 13.6715 16.5393 13.2143 16.5393C11.8847 16.5393 11.2852 15.6311 11.2852 14.5703Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0625 18.5625H3V19.25H16.0625C16.4406 19.25 16.75 18.9406 16.75 18.5625V17.875C16.75 18.2531 16.4406 18.5625 16.0625 18.5625Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.11179631db5f1b66d3c3a78e363dd863.svg";
export { ForwardRef as ReactComponent };